import { create } from "zustand";
import { persist } from "zustand/middleware";
import config from "../config";
import { clearAllCookies } from "../utils/common.util";

const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      baseUrl: config.API_BASE_URL,
      setToken: (token) => {
        set({ token: token });
      },
      // ✅ LOGIN
      setUser: (userData) => {
        set({ user: userData });
      },

      // ✅ UPDATE USER
      updateUser: (newData) => {
        const currentUser = get().user;

        if (!currentUser) return;

        set({
          user: {
            ...currentUser,
            ...newData,
          },
        });
      },
      setBaseUrl: (baseUrl) => {
        set({ baseUrl: baseUrl });
      },
      // ✅ LOGOUT
      logout: () => {
        set({ user: null, token: null, baseUrl: null });
        localStorage.removeItem("auth-storage"); // optional
        clearAllCookies();
        localStorage.clear();
      },
    }),
    {
      name: "auth-storage", // localStorage key

      // ✅ persist only needed data
      partialize: (state) => ({
        user: state.user,
        token: state.token,
        baseUrl: state.baseUrl,
      }),
    },
  ),
);

export default useAuthStore;
